import React from "react";

/**
 * Sahadaki dokunmatik ekranların büyük eylem düğmesi
 * (Asma / Asma SPV / Toplama).
 *
 * Tasarım kararları:
 *  - Metin rengi AÇIKÇA verilir. Eskiden miras alınıyordu; koyu temada açık
 *    renge dönüp soluk sarı zeminde okunmaz oluyordu.
 *  - Soluk sarı (`bg-mainYellow`) zemin kalktı. Yerine tema yüzeyi + eyleme
 *    göre renk şeridi geldi: operatör dört sarı kutuyu okumak yerine rengi
 *    tanıyor (yeşil = tamamla, mavi = ekle, kırmızı = arıza, gri = çıkış).
 *  - Dokunma hedefi 150px korundu; `active:` ile basma geri bildirimi ve
 *    `touch-manipulation` ile çift dokunma yakınlaştırması kapatıldı.
 */

/*
 * İkon kutusunun zemini her iki temada da SABİT açık kalır (`ICON_PLATE`).
 *
 * Sebep: ikonlar PNG çizim — `cancel`, `exit-icon`, `addOrder` siyah çizgi
 * resmi, `ariza` ise sarı/siyah renkli. Koyu temada kutu da koyarsa siyah
 * çizimler kayboluyor. `invert` filtresi siyahları kurtarır ama sarı üçgeni
 * maviye çevirir. Açık plaka hepsinde çalışır ve ileride eklenecek ikon da
 * bozulmaz — pictogram'ı kendi kağıdında tutuyoruz.
 *
 * Renk kodu bu yüzden zeminde değil, plakanın kenarlığında ve üst şeritte.
 */
const ICON_PLATE = "bg-[#eef2f7]";

const TONES = {
  neutral: { accent: "bg-gray-400", edge: "border-gray-300", ring: "hover:border-gray-400" },
  ok: { accent: "bg-state-ok", edge: "border-state-ok/40", ring: "hover:border-state-ok" },
  info: { accent: "bg-state-info", edge: "border-state-info/40", ring: "hover:border-state-info" },
  warn: { accent: "bg-state-warn", edge: "border-state-warn/40", ring: "hover:border-state-warn" },
  bad: { accent: "bg-state-bad", edge: "border-state-bad/40", ring: "hover:border-state-bad" },
};

export default function TopButton({ title, icon, onClick, tone = "neutral" }) {
  const t = TONES[tone] || TONES.neutral;

  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        "relative m-[10px] flex h-[150px] w-[150px] shrink-0 select-none flex-col items-center justify-between",
        "overflow-hidden rounded-xl border border-line bg-surface py-4 shadow-card",
        "text-content transition-all touch-manipulation",
        "hover:shadow-raised active:scale-[0.97] active:shadow-card",
        t.ring,
      ].join(" ")}
    >
      {/* Eylem rengi — üst şerit */}
      <span className={`absolute inset-x-0 top-0 h-1.5 ${t.accent}`} />

      <span
        className={`mt-2 flex h-[86px] w-[86px] items-center justify-center rounded-xl border-2 ${ICON_PLATE} ${t.edge}`}
      >
        <img
          src={icon}
          alt=""
          aria-hidden
          className="h-[62px] w-[62px] object-contain"
        />
      </span>

      <span className="px-2 text-center text-[20px] font-bold leading-tight text-content">
        {title}
      </span>
    </button>
  );
}
